<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/sebitvcloud.jpg" alt="" />
      <h3 v-if="this.$route.query.token && !errorMsg">Lütfen bekleyiniz, işleminiz devam ediyor.</h3>
      <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";

export default {
  name: "SebitVCloud",
  components: {Loading},
  data() {
    return {
      loading: true,
      token: null,
      clientid: null,
      sebitUserData: null,
      errorMsg: '',
    }
  },
  beforeMount() {
    this.baslat(this.$route.query)
  },
  /**
   * Sebit VCloud, farklı ürünleri (HLL/Kidzwonder3D/Raz-Plus/...) TEK bir
   * route'ta (/sebitvcloud), yalnızca `clientid` query param'ıyla ayırıyor.
   * Vue Router aynı route'a query-only geçişte component'i YENİDEN KURMAZ —
   * yalnızca `beforeMount`'a güvenmek, kullanıcı aynı sekmede önce bir ürüne
   * sonra başka birine tıklarsa (sayfa tam yenilenmeden), ikinci ürünün BİRİNCİ
   * ürünün token/clientid/kullanıcı verisiyle çözülmesine yol açıyordu —
   * 13.09.2026'da canlıda somut olarak yakalandı (HLL URL'sine gidildi ama
   * resolve() isteği bir önceki KW3D ziyaretinin clientid + appGeneratedId'sini
   * gönderdi). `beforeRouteUpdate` bu class'taki geçişleri de yakalar.
   */
  beforeRouteUpdate(to, from, next) {
    this.baslat(to.query)
    next()
  },
  methods: {
    baslat(query) {
      this.loading = true
      this.errorMsg = ''
      this.sebitUserData = null
      this.token = null
      this.clientid = null
      if (query.token && query.clientid) {
        this.token = query.token
        this.clientid = query.clientid
        this.sebitValidate()
      } else {
        this.loading = false
      }
    },
    async sebitValidate() {
      const ENV = 'prod';
      const baseUrl = 'https://ueslms-service-api.ey.r.appspot.com';
      const url = `${baseUrl}/sebit-validate?token=${this.token}&clientid=${this.clientid}&env=${ENV}`;

      // console.log('validate url', url);

      try {
        const response = await axios.get(url, {
          timeout: 30000, // 30 saniye timeout
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: false // CORS için
        });

        // console.log('validate response.data', response.data);
        // console.log('validate response.status', response.status);

        const data = response.data;
        if (data.appGeneratedId !== null) {
          this.sebitUserData = data;
          this.errorMsg = '';

          // Kullanıcıyı UES'te bul/oluştur ve hedef platforma hazır redirect
          // url'ini al.
          await this.ueslmsResolve();
        } else {
          this.loading = false;
          this.errorMsg = 'Bir hata oluştu: appGeneratedId null.';
        }
      } catch (error) {
        this.loading = false;

        // Detaylı hata loglaması
        // console.error('Axios Error:', error);
        // console.error('Error Message:', error.message);
        // console.error('Error Response:', error.response);
        // console.error('Error Request:', error.request);

        if (error.response) {
          // Sunucu yanıt verdi ama hata kodu döndü (4xx, 5xx)
          // console.error('Response Status:', error.response.status);
          // console.error('Response Data:', error.response.data);
          this.errorMsg = `Sunucu hatası: ${error.response.status} - ${JSON.stringify(error.response.data)}`;
        } else if (error.request) {
          // İstek gönderildi ama yanıt alınamadı (CORS, network hatası)
          // console.error('No response received');
          this.errorMsg = 'Sunucudan yanıt alınamadı. CORS veya ağ hatası olabilir.';
        } else {
          // İstek oluşturulurken hata oluştu
          this.errorMsg = `İstek hatası: ${error.message}`;
        }
      }
    },

    /**
     * Sebit payload'ını UES'e çözdürür.
     *
     * Sınıf/kademe/kampüs eşlemesi, kullanıcı oluşturma VE hedef platforma
     * giden şifreli redirect url'i artık burada değil, UES tarafında
     * (Api\V2\Platforms\SebitSsoController) üretiliyor. clientid → okul →
     * hedef platform eşlemesi eskiden bu bileşende elle tutulan bir
     * `platformMap`'teydi (yeni clientid eklemek deploy gerektiriyordu);
     * 01.09.2026'da tamamen kaldırıldı — artık `sebit_credentials`/
     * `sebit_products` tablolarından (admin > Sebit) geliyor, bkz.
     * .claude/notes/sebit-entegrasyonu.md.
     *
     * Ayrıca hedef platformların AES secretKey'leri artık tarayıcıda hiç
     * bulunmuyor (K12Net/Gradingly'deki "sır tarayıcıya inmez" ilkesiyle
     * aynı) — bu bileşen yalnızca UES'in döndürdüğü hazır `redirect_url`'e
     * yönlenir.
     */
    async ueslmsResolve() {
      try {
        const response = await axios.post(
          'https://www.ueslms.com/api/v2/sebit/sso/resolve',
          {
            clientid: this.clientid,
            user: this.sebitUserData,
          },
          { timeout: 30000, headers: {'Content-Type': 'application/json', 'Accept': 'application/json'} }
        );

        if (response.data && response.data.success && response.data.redirect_url) {
          this.loading = false;
          window.location.href = response.data.redirect_url;
          return;
        }

        this.loading = false;
        this.errorMsg = (response.data && response.data.message) || 'Kullanıcı çözümlenemedi.';
      } catch (error) {
        this.loading = false;

        if (error.response && error.response.data && error.response.data.message) {
          this.errorMsg = error.response.data.message;
        } else {
          this.errorMsg = 'UES kullanıcı servisine ulaşılamadı.';
        }
      }
    },
  }
}
</script>
